import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { SeasonRateDetails } from '../seasonRatesSlice';

interface SeasonRatePickerItemProps {
  seasonRateItem: SeasonRateDetails;
  onCheckboxChange: (id: string, isChecked: boolean) => void;
  isChecked: boolean;
}

const SeasonRatePickerItem: React.FC<SeasonRatePickerItemProps> = ({
  seasonRateItem,
  onCheckboxChange,
  isChecked,
}) => {
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onCheckboxChange(seasonRateItem.id, event.target.checked);
  };

  return (
    <Row
      className="border"
      style={{ backgroundColor: seasonRateItem.seasonRateColorHex }}
    >
      <Col xs="auto">
        <Form.Check
          type="checkbox"
          name="seasonRatePickerItemId"
          checked={isChecked}
          onChange={handleCheckboxChange}
        />
      </Col>
      <Col
        xs="auto"
        className="d-flex align-items-center"
        style={{ width: '150px', whiteSpace: 'normal' }}
      >
        {seasonRateItem.seasonRateType}
      </Col>
      <Col
        xs="auto"
        className="d-flex align-items-center"
        style={{ width: '350px', whiteSpace: 'normal' }}
      >
        {seasonRateItem.seasonName}
      </Col>
      <Col xs="auto" className="d-flex align-items-center">
        {seasonRateItem.startDateString} - {seasonRateItem.endDateString}
      </Col>
    </Row>
  );
};

export default SeasonRatePickerItem;
